import { useMutation } from '@tanstack/react-query';
import type { BatchUploadRequest } from '../../../infrastructure/ProductClient';
import { ProductClient } from '../../../infrastructure/ProductClient';
import type { WpProductPayload } from '../../../models/WpProduct';

export const useUploadToWordPress = () => {
  return useMutation({
    mutationFn: (payload: WpProductPayload) => ProductClient.uploadProduct(payload),
  });
};

export const useUploadMultipleToWordPress = () => {
  return useMutation({
    mutationFn: (request: BatchUploadRequest) => ProductClient.uploadProducts(request),
  });
};
